import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadWorkArea, loadWorkAreaSuccess } from './workArea.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { WorkAreasService } from '@services';
import { IPaginationParams } from '@interfaces';

@Injectable()
export class WorkAreaEffects {
  constructor(
    private actions$: Actions,
    private workAreaService: WorkAreasService,
    private toast: ToastrService,
  ) {}
  loadWorkArea$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadWorkArea),
      mergeMap(() =>
        this.workAreaService.getAllWorkArea({ pageNum: 1, pageLimit: 'all' } as IPaginationParams).pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const workArea = response.data.map((item: any) => ({
                id: item._id,
                name: item.name.hebrew,
                hebrewName: item.name.hebrew,
                arabicName: item.name.arabic,
              }));
              return loadWorkAreaSuccess({ workArea });
            } else {
              this.toast.error(response.message);
              return { type: '[WorkArea] Load Work Failed' };
            }
          }),
          catchError((error: any) => {
            this.toast.error(error);
            return of({ type: '[Work Area] Load Work Failed' });
          }),
        ),
      ),
    ),
  );
}
